import { format, parseISO } from "date-fns";
import { fr } from "date-fns/locale";

export const joursUS = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
export const mois = [
  'Janvier',
  'Février',
  'Mars',
  'Avril',
  'Mai',
  'Juin',
  'Juillet',
  'Août',
  'Septembre',
  'Octobre',
  'Novembre',
  'Décembre',
];

export const referenceToTable = (reference = []) => {
  return reference[0].reference.split(',');
};

export const dateFormat = (date, separation = '-') => {
  const temps = new Date(date);

  return {
    year: temps.getFullYear().toString(),
    month: ('0' + (temps.getMonth() + 1)).slice(-2),
    day: ('0' + temps.getDate()).slice(-2),
    full: `${('0' + temps.getDate()).slice(-2)}${separation}${('0' + (temps.getMonth() + 1)).slice(
      -2
    )}${separation}${temps.getFullYear().toString()}`,
    stringFull: `${joursUS[temps.getDay()]} ${('0' + temps.getDate()).slice(-2)} ${mois[temps.getMonth()]
      } ${temps.getFullYear()}`,
  };
};

export const hourFormat = (date) => {
  const temps = new Date(date);
  return {
    hour: ('0' + temps.getHours()).slice(-2),
    minute: ('0' + temps.getMinutes()).slice(-2),
    second: ('0' + temps.getSeconds()).slice(-2),
    full: `${('0' + temps.getHours()).slice(-2)}:${('0' + temps.getMinutes()).slice(-2)}:${(
      '0' + temps.getSeconds()
    ).slice(-2)}`,
  };
};

export const maxText = (text, max = 21) => {
  if (text.length > max) {
    return text.slice(0, max - 3) + '...';
  } else {
    return text;
  }
};

export const sorted = (table, key, reverse = false) => {
  let newTable = JSON.parse(JSON.stringify(table));
  newTable.sort((a, b) => {
    if (a[key] < b[key]) return -1;
    if (a[key] > b[key]) return 1;
    return 0;
  });
  if (reverse) newTable.reverse();
  return newTable;
};

export const filterMaterialData = (tab) => {
  return tab.map((el) => {
    return {
      nature: el.nature || '',
      material: el.material || '',
      refName: el.refName || '',
      quantity: el.quantity || '',
      quantityLabel: el.quantityLabel || '',
      pose: el.pose || '',
      depot: el.depot || '',
      surface: el.surface || '',
      statut: el.statut || false,
      comments: el.comments || '',
    };
  });
};
export const _filterMaterialData = (list = []) => {
  if (!Array.isArray(list)) return [];

  return list.map((m, index) => {
    const indexRef = typeof m?.indexRef === 'number' ? m.indexRef : index;

    // Détection du nouveau format "APRÈS"
    const hasAfterShape =
      m && (typeof m.name === 'string' || typeof m.address === 'string' || typeof m.description === 'string');

    if (hasAfterShape) {
      const name = (m.name || '').trim();
      const address = (m.address || '').trim();
      const description = (m.description || '').trim();

      return {
        // ✅ on garde la shape "APRÈS" (MaterialData)
        indexRef,
        name,
        address,
        poseAddress: (m.poseAddress || address || '').trim(),
        quantity: m.quantity ?? null,
        quantityLabel: (m.quantityLabel || '').trim(),
        description,
        surface: (m.surface || '').trim(),
        referenceQr: (m.referenceQr || '').trim() || undefined,

        // ✅ compat legacy (si certains écrans lisent encore ces champs)
        nature: description,
        material: name,
        pose: address,
        depot: (m.depot || '').trim(),
        refName: (m.refName || '').trim(),
        statut: Boolean(m.statut),
        comments: (m.comments || '').trim(),
      };
    }

    // Sinon : format legacy (on le laisse vivre)
    return {
      indexRef,

      nature: (m.nature || '').trim(),
      material: (m.material || '').trim(),
      refName: (m.refName || '').trim(),
      quantity: m.quantity ?? null,
      quantityLabel: (m.quantityLabel || '').trim(),
      pose: (m.pose || '').trim(),
      depot: (m.depot || '').trim(),
      surface: (m.surface || '').trim(),
      statut: Boolean(m.statut),
      comments: (m.comments || '').trim(),

      // ✅ on remplit aussi la nouvelle shape à partir du legacy (utile pour Edit "APRÈS")
      name: ((m.name || m.material) || '').trim(),
      address: ((m.address || m.pose || m.poseAddress) || '').trim(),
      poseAddress: ((m.poseAddress || m.address || m.pose) || '').trim(),
      description: ((m.description || m.nature) || '').trim(),
      referenceQr: (m.referenceQr || '').trim() || undefined,
    };
  });
};

export function parseQuantityLabel(input) {
  if (!input) return null;

  // extrait le premier nombre dans le texte
  const match = input.match(/[\d,.]+/);

  if (!match) return null;

  // remplace virgule par point pour les nombres décimaux
  const num = parseFloat(match[0].replace(',', '.'));

  return isNaN(num) ? null : num;
}


// 👇 helper : extrait un nombre depuis un texte ("3 u", "250 ml", "10,5 m", etc.)
export const extractNumericQuantity = (value) => {
  if (!value) return '';

  const match = value.match(/[\d,.]+/); // prend le premier bloc de chiffres
  if (!match) return '';

  const num = parseFloat(match[0].replace(',', '.'));
  if (isNaN(num)) return '';

  // si tu veux absolument un Int côté backend, on arrondit :
  return Math.round(num);
};

export const renderOrDash = (value) => {
  if (value === null || value === undefined) return '-';
  const str = String(value).trim();
  return str === '' ? '-' : str;
};

export const getQuantityDisplay = (material) => {
  if (material?.quantityLabel && String(material.quantityLabel).trim() !== '') {
    return material.quantityLabel;
  }
  if (typeof material?.quantity === 'number') {
    return material.quantity;
  }
  if (material?.quantity) {
    return material.quantity;
  }
  return '-';
};

export const dateFormatted = (date) => {
  if (!date) return {};
  const d = new Date(date);
  return {
    year: d.getFullYear().toString(),
    month: ("0" + (d.getMonth() + 1)).slice(-2),
    day: ("0" + d.getDate()).slice(-2),
  };
};

export const formatDateTime = (dateString) => {
  const date = dateString ? parseISO(dateString) : new Date();
  return format(date, "EEEE dd MMMM yyyy 'à' HH:mm", { locale: fr });
};

/**
 * 🔍 Essaie d'extraire une liste de tâches à partir de `description`
 *
 * Gère 3 cas :
 * 1. Nouveau format JSON :
 *    '[{ "label": "Tâche 1", "quantityLabel": "2 u" }, ...]'
 * 2. Ancien JSON array de strings :
 *    '["Tâche 1","Tâche 2"]'
 * 3. Texte simple / multi-lignes :
 *    "Tâche 1\nTâche 2"
 *
 * Retourne :
 * {
 *   isMulti: boolean,
 *   tasks: Array<{ label: string, quantityLabel?: string }> | string[],
 *   raw: string
 * }
 */
export const getTasksFromDescription = (description) => {
  // Si ce n'est pas une string -> rien à afficher
  if (typeof description !== "string") {
    return { isMulti: false, tasks: [], raw: "" };
  }

  const trimmed = description.trim();
  if (!trimmed) {
    return { isMulti: false, tasks: [], raw: "" };
  }

  // 1️⃣ Tentative : on considère que `description` est un JSON
  try {
    const parsed = JSON.parse(trimmed);

    if (Array.isArray(parsed)) {
      // On normalise les éléments :
      // - objet { label, quantityLabel }
      // - OU string simple
      const normalized = parsed
        .map((item) => {
          // Nouveau format : objet
          if (item && typeof item === "object") {
            const label =
              typeof item.label === "string" ? item.label.trim() : "";
            const quantityLabel =
              typeof item.quantityLabel === "string"
                ? item.quantityLabel.trim()
                : "";

            if (!label && !quantityLabel) return null;
            return { label, quantityLabel };
          }

          // Ancien format : string
          if (typeof item === "string") {
            const label = item.trim();
            if (!label) return null;
            return { label, quantityLabel: "" };
          }

          return null;
        })
        .filter(Boolean);

      if (normalized.length > 0) {
        return {
          isMulti: true,
          tasks: normalized,
          raw: trimmed,
        };
      }
    }
  } catch (e) {
    // JSON.parse a échoué → on passe au fallback texte
  }

  // 2️⃣ Fallback : texte simple / multi-lignes
  const lines = trimmed
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter((l) => l.length > 0);

  if (lines.length > 1) {
    // Plusieurs lignes → on les traite comme plusieurs tâches sans quantité
    const tasks = lines.map((label) => ({ label, quantityLabel: "" }));
    return {
      isMulti: true,
      tasks,
      raw: trimmed,
    };
  }

  // Une seule ligne → on garde l'ancien comportement
  return {
    isMulti: false,
    tasks: [],
    raw: trimmed,
  };
};
